import {QuestionnaireStep} from '@letrustech/letrus-api-interfaces/dist/interfaces/letrus_api';
import React from 'react';
import styles from './TextChipsList.module.scss';

interface TextChipListProps {
  question: QuestionnaireStep | undefined;
  name: string;
}

const TextChipList: React.FC<TextChipListProps> = ({name, question}) => {
  return (
    <ul className={styles.wrapper}>
      {question?.question.choices.map((choice) => (
        <li key={choice.id}>
          <input
            type="checkbox"
            name={name}
            value={choice.id}
            className={styles.input}
            id={choice.name}
            aria-label={choice.name}
          />
          <label
            htmlFor={choice.name}
            className={styles.label}
            aria-hidden="true"
          >
            {choice.name}
          </label>
        </li>
      ))}
    </ul>
  );
};

export default TextChipList;
